import React from 'react';
import { LabelType } from './types';
import { Tags } from '$components/common/tags';

export const createCardLabel = (type: LabelType): JSX.Element => {
  const item = mapper[type];

  return <Tags icon={item.svg} items={[item.title]} />;
};

export const Label: Record<Capitalize<LabelType>, LabelType> = {
  Data_collection: 'data_collection',
  Story: 'story',
  Topic: 'topic',
  Widget: 'widget'
};

export const LabelDisplay: Record<LabelType, string> = {
  data_collection: 'Data Collection',
  story: 'Story',
  topic: 'Topic',
  widget: 'Widget'
};

export const LabelIcon: Record<LabelType, React.ReactElement> = {
  data_collection: (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.3125 7.92613L6.00003 10.441L1.68753 7.92613C1.60214 7.88362 1.50376 7.87524 1.41242 7.9027C1.32107 7.93016 1.24363 7.9914 1.19584 8.07395C1.14806 8.1565 1.13352 8.25416 1.1552 8.34705C1.17688 8.43993 1.23314 8.52107 1.31253 8.57394L5.81253 11.1989C5.86987 11.2324 5.93505 11.25 6.00143 11.25C6.06781 11.25 6.133 11.2324 6.19034 11.1989L10.6903 8.57394C10.7336 8.54949 10.7715 8.51669 10.8019 8.47746C10.8324 8.43823 10.8547 8.39334 10.8677 8.3454C10.8806 8.29746 10.884 8.24743 10.8774 8.1982C10.8709 8.14897 10.8546 8.10153 10.8296 8.05864C10.8046 8.01574 10.7713 7.97824 10.7317 7.94831C10.6921 7.91838 10.6469 7.89662 10.5988 7.8843C10.5507 7.87197 10.5006 7.86932 10.4515 7.8765C10.4023 7.88368 10.3551 7.90055 10.3125 7.92613Z'
        fill='#565C65'
      />
      <path
        d='M10.3125 5.67613L6.00003 8.19097L1.68753 5.67613C1.60214 5.63362 1.50376 5.62524 1.41242 5.6527C1.32107 5.68016 1.24363 5.7414 1.19584 5.82395C1.14806 5.9065 1.13352 6.00416 1.1552 6.09705C1.17688 6.18993 1.23314 6.27107 1.31253 6.32394L5.81253 8.94894C5.86987 8.98238 5.93505 9 6.00143 9C6.06781 9 6.133 8.98238 6.19034 8.94894L10.6903 6.32394C10.7336 6.29949 10.7715 6.26669 10.8019 6.22746C10.8324 6.18823 10.8547 6.14334 10.8677 6.0954C10.8806 6.04746 10.884 5.99743 10.8774 5.9482C10.8709 5.89897 10.8546 5.85153 10.8296 5.80864C10.8046 5.76574 10.7713 5.72824 10.7317 5.69831C10.6921 5.66838 10.6469 5.64662 10.5988 5.6343C10.5507 5.62197 10.5006 5.61932 10.4515 5.6265C10.4023 5.63368 10.3551 5.65055 10.3125 5.67613Z'
        fill='#565C65'
      />
      <path
        d='M1.31249 4.07387L5.81249 6.69887C5.86983 6.73231 5.93502 6.74993 6.0014 6.74993C6.06778 6.74993 6.13297 6.73231 6.19031 6.69887L10.6903 4.07387C10.7469 4.04084 10.7939 3.99356 10.8265 3.93673C10.8592 3.87989 10.8763 3.8155 10.8763 3.74996C10.8763 3.68442 10.8592 3.62003 10.8265 3.5632C10.7939 3.50637 10.7469 3.45908 10.6903 3.42606L6.19031 0.801056C6.13297 0.767619 6.06778 0.75 6.0014 0.75C5.93502 0.75 5.86983 0.767619 5.81249 0.801056L1.31249 3.42606C1.25589 3.45908 1.20892 3.50637 1.17628 3.5632C1.14364 3.62003 1.12646 3.68442 1.12646 3.74996C1.12646 3.8155 1.14364 3.87989 1.17628 3.93673C1.20892 3.99356 1.25589 4.04084 1.31249 4.07387Z'
        fill='#565C65'
      />
    </svg>
  ),
  story: (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.625 1.5H3.375C3.17609 1.5 2.98532 1.57902 2.84467 1.71967C2.70402 1.86032 2.625 2.05109 2.625 2.25V10.5C2.62503 10.5669 2.64298 10.6326 2.67696 10.6903C2.71095 10.7479 2.75975 10.7954 2.81829 10.8278C2.87684 10.8603 2.94299 10.8764 3.00989 10.8747C3.07679 10.8729 3.142 10.8533 3.19875 10.8178L6 9.06703L8.80172 10.8178C8.85846 10.8532 8.92362 10.8727 8.99045 10.8744C9.05728 10.8761 9.12335 10.8599 9.18182 10.8275C9.24029 10.7951 9.28903 10.7476 9.32299 10.69C9.35696 10.6325 9.37491 10.5669 9.375 10.5V2.25C9.375 2.05109 9.29598 1.86032 9.15533 1.71967C9.01468 1.57902 8.82391 1.5 8.625 1.5Z'
        fill='#565C65'
      />
    </svg>
  ),
  topic: (
    <svg
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 0.125C4.03582 0.125 3.09329 0.410914 2.2916 0.946586C1.48991 1.48226 0.865067 2.24363 0.496089 3.13442C0.127112 4.02521 0.030571 5.00541 0.218674 5.95107C0.406777 6.89672 0.871076 7.76536 1.55286 8.44715C2.23464 9.12893 3.10328 9.59323 4.04894 9.78133C4.99459 9.96943 5.97479 9.87289 6.86558 9.50391C7.75637 9.13494 8.51775 8.51009 9.05342 7.7084C9.58909 6.90671 9.875 5.96418 9.875 5C9.87351 3.70753 9.35942 2.46842 8.4455 1.5545C7.53159 0.640581 6.29248 0.126489 5 0.125ZM8.67313 3.125H7.00203C6.79159 2.35293 6.43691 1.62766 5.95672 0.9875C6.5369 1.12687 7.08008 1.39005 7.54902 1.75899C8.01797 2.12794 8.40159 2.59392 8.6736 3.125H8.67313ZM9.125 5C9.12533 5.38042 9.07279 5.75904 8.96891 6.125H7.16375C7.27875 5.37941 7.27875 4.62059 7.16375 3.875H8.96891C9.07279 4.24096 9.12533 4.61958 9.125 5ZM5 1.01562C5.56153 1.61681 5.97837 2.33827 6.21875 3.125H3.78125C4.02139 2.33816 4.43826 1.61665 5 1.01562ZM3.78125 6.875H6.21875C5.97862 7.66184 5.56174 8.38335 5 8.98438C4.43848 8.38319 4.02163 7.66173 3.78125 6.875ZM3.59844 6.125C3.46969 5.38053 3.46969 4.61947 3.59844 3.875H6.40531C6.53406 4.61947 6.53406 5.38053 6.40531 6.125H3.59844ZM5.9586 9.0125C6.43878 8.37234 6.79346 7.64707 7.00391 6.875H8.67547C8.40327 7.40628 8.01936 7.87239 7.55007 8.24135C7.08079 8.6103 6.53724 8.87337 5.95672 9.0125H5.9586Z'
        fill='#565C65'
      />
    </svg>
  ),
  widget: (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.68751 5.45766C4.74453 5.42474 4.79187 5.37738 4.82479 5.32036C4.8577 5.26334 4.87502 5.19865 4.87501 5.13281V1.75781C4.87467 1.69803 4.86005 1.63919 4.83235 1.5862C4.80466 1.53321 4.76469 1.48762 4.7158 1.45321C4.6669 1.41881 4.61048 1.3966 4.55125 1.38843C4.49203 1.38026 4.43171 1.38637 4.37532 1.40625C3.28078 1.79363 2.36031 2.55874 1.77939 3.56403C1.19847 4.56933 0.995191 5.74887 1.2061 6.89063C1.21703 6.94967 1.24198 7.00522 1.27885 7.05261C1.31572 7.10001 1.36344 7.13785 1.41798 7.16297C1.46713 7.18595 1.52075 7.1978 1.57501 7.19766C1.64083 7.19768 1.70549 7.18038 1.76251 7.1475L4.68751 5.45766ZM4.12501 2.32594V4.91625L1.88063 6.21141C1.87501 6.14062 1.87501 6.06938 1.87501 6C1.87567 5.23986 2.08608 4.49464 2.48307 3.84639C2.88005 3.19815 3.44822 2.67202 4.12501 2.32594ZM10.875 6C10.8754 7.07022 10.5236 8.11082 9.87385 8.96125C9.22413 9.81168 8.31262 10.4247 7.27995 10.7057C6.24728 10.9867 5.15084 10.92 4.1598 10.516C3.16876 10.112 2.3382 9.39317 1.79626 8.47031C1.77099 8.42769 1.75443 8.38048 1.74752 8.33141C1.74061 8.28234 1.74349 8.23239 1.756 8.18445C1.76851 8.1365 1.7904 8.09151 1.8204 8.05207C1.8504 8.01264 1.88792 7.97954 1.93079 7.95469L5.62501 5.80453V1.5C5.62501 1.40054 5.66452 1.30516 5.73484 1.23483C5.80517 1.16451 5.90055 1.125 6.00001 1.125C6.85073 1.12543 7.68654 1.34838 8.42446 1.77169C9.16239 2.19501 9.77675 2.80397 10.2066 3.53813C10.2117 3.54563 10.2164 3.55313 10.2211 3.56109C10.2258 3.56906 10.2305 3.57844 10.2347 3.58687C10.6553 4.32149 10.8761 5.15349 10.875 6Z'
        fill='#565C65'
      />
    </svg>
  )
};

const mapper = {
  data_collection: {
    title: 'Data Collection',
    svg: LabelIcon.data_collection
  },
  story: {
    title: 'Story',
    svg: LabelIcon.story
  },
  topic: {
    title: 'Topic',
    svg: LabelIcon.topic
  }
};
